import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import TarjetaService from "../../../services/pagos/TarjetaService"
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import $ from "jquery";
import authService from "../../../services/login/auth.service";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

const DetalleFila = ({ data }) => (
  <div className="row" style={{ margin: 0,fontSize: 13, marginBottom: 20 }}>
    <div className="col-md-12">
      <p style={{ fontWeight: 500, marginBottom: 0}}>Detalles:</p>
    </div>
    <div className="col-md-2">
      <p style={{marginBottom: 0}}>Pago Mínimo: {data.pagoMin}</p>
    </div>
    <div className="col-md-3">
      <p style={{marginBottom: 0}}>Saldo Plan: {data.saldoPlan}</p>
    </div>
    <div className="col-md-3">
      <p style={{marginBottom: 0}}>Deuda Total: {data.deudaTotal}</p>
    </div>
    <div className="col-md-2">
      <p style={{marginBottom: 0}}>Saldo Mora: {data.saldoMora}</p>
    </div>
    <div className="col-md-2">
      <p style={{marginBottom: 0}}>Días Mora: {data.diasMora}</p>
    </div>
  </div>
);
export default class TarjetaPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

  }

  getInitialState = () => ({
    cuentasOrigen: [],
    selectedOption: this.props.itemSelected,
    opcion: [],
    disabledNext: true,
    listaTarjeta: [],
  })


  componentDidMount() {
    this.getListaTarjeta();
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
          right: [
              {
                  text: "Aceptar",
                  className: "success",
                  action: function () {
                      Popup.close();
                  },
              },
          ],
      },
  });
  getListaTarjeta() {

    var respuesta = [];
    trackPromise(
      TarjetaService.resumenTarjetas()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          
          if (jsonData.codigoRetorno === "0") {

            for (var i = 0; i < jsonData.resultado.length; i++) {
             //console.log(jsonData.resultado[i])
              var nro = jsonData.resultado[i].nroTarjeta;
             var identificador = nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length)
              respuesta.push({
                id: jsonData.resultado[i].nroTarjeta,
                tarjeta: identificador,
                tipo: jsonData.resultado[i].tipo,
                vencimiento: jsonData.resultado[i].fechaVencPagoMin,
                pagoMin: formatoSeparadorMilesValue(jsonData.resultado[i].pagoMinimo)+" GS",
                linea: formatoSeparadorMilesValue(jsonData.resultado[i].linea)+" GS",
                saldo: formatoSeparadorMilesValue(jsonData.resultado[i].saldoNormal)+" GS",
                saldoPlan: formatoSeparadorMilesValue(jsonData.resultado[i].saldoPlan)+" GS",
                deudaTotal: formatoSeparadorMilesValue(jsonData.resultado[i].deudaTotal)+" GS",
                saldoMora: formatoSeparadorMilesValue(jsonData.resultado[i].saldoMora)+" GS",
                diasMora: jsonData.resultado[i].diasMora,
                moneda:jsonData.resultado[i].moneda
              });
            }

            this.setState({ listaTarjeta: respuesta });
          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            return;
          }
        }
        ).catch(function (error) {
          //  authService.logout()
          console.log(error)
        }));



    return this.state.listaTarjeta;
  }

  getColumn() {
    return [
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "50px",
      },
      {
        name: "Tarjeta",
        selector: row => row.tarjeta,
        width: "180px",
      },
      {
        name: "Tipo",
        selector: row => row.tipo,
      },
      {
        name: "Vencimiento",
        selector: row => row.vencimiento
      },
      {
        name: "Pago Mímino",
        selector: row => row.pagoMin,
        omit: true
      },
      {
        name: "Línea",
        selector: row => row.linea,
        width: "130px",
        right: true
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
        width: "130px",
        right: true
      },
      {
        name: "Saldo Plan",
        selector: row => row.saldoPlan,
        omit: true
      },
      {
        name: "Deuda Total",
        selector: row => row.deudaTotal,
        omit: true
      },
      {
        name: "Saldo Mora",
        selector: row => row.saldoMora,
        omit: true
      },
      {
        name: "Días Mora",
        selector: row => row.diasMora,
        omit: true
      },
    ];
  }

  selGrupoEvt = (e) => {
    this.preSele = e.currentTarget;
   
    this.setState({ disabledNext: false });
    for (var i = 0; i < this.state.listaTarjeta.length; i++) {
      var ah = this.state.listaTarjeta[i]
      var ah_id = "radio_" + ah.id;
      if (ah_id === this.preSele.id) {
        console.log(ah)
        //this.props.datoAhorro(ah.descripcion, ah.depositado, ah.ahorro);
        this.props.rptPaso1(
          ah.id, 
          ah.tarjeta, 
          ah.tipo, 
          ah.deudaTotal, 
          ah.saldo,
          ah.saldoPlan,
          ah.diasMora,
          ah.saldoMora,
          ah.linea,
          ah.moneda
        );
      }
    }
    //this.props.rptPaso1(this.preSele.id);
    this.enableNext();
  };
  enableNext() {
    this.checkGrilla();
  }

  checkGrilla() {
    if (this.preSele !== undefined) {
      $("#" + this.preSele.id).prop("checked", true);
    }
  
  }

  seleccionarFila(row){
    //console.log( row)
    var radio = document.getElementById("radio_" + row.id)
    radio.click(this.selGrupoEvt);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Tarjeta
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Datos de Pago
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-md-12" id="tarjetas-pagos">
                <label className="input-label-bold">Seleccione la tarjeta de crédito que desea pagar *</label>
                <div className="row justify-content-md-center">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={this.getColumn()}
                      data={this.state.listaTarjeta}
                      dense={true}
                      pagination={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                      responsive={true}
                      striped={true}
                      pointerOnHover
                      onRowClicked={(e) => this.seleccionarFila(e)} 
                      expandableRows
                      expandableRowsComponent={
                        DetalleFila
                      }/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-md-10">
              <label
                className="input-label-bold-obligatorio float-left">
                (*) Campos Obligatorios
                      <br />
              </label>
          </div>
          <div className="col-md-2">
              <button
               disabled={this.state.disabledNext}
                className="btn btn-cu-primary"
                onClick={this.props.paso1Next}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
          </div>
        </div>

      </div>
    );
  }
}